import React from 'react';
import '../assets/css/Totd.css';

const AccountDeletion = () => {
  return (
    <div className="container">
      <section className="ctext section-body" id="account-deletion" data-rv-view="0">
        <div className="filter-container">
          <div className="container">
            <div className="row">
              <div className="totdText">
                <h3>Delete Your RippaDay Account</h3>
                <p>You can request deletion of your RippaDay account and associated personal information from this page.</p>

                <h4>How to request deletion</h4>
                <p>Email <a href="mailto:support@rippaday.com?subject=Delete%20my%20RippaDay%20account">support@rippaday.com</a> from the email address linked to your RippaDay account with the subject line <strong>Delete my RippaDay account</strong>.</p>
                <p>If you are signed in to the mobile app, you can also open this page from Account Management and use the same request process.</p>

                <h4>What will be deleted</h4>
                <p>After we verify your request, we will delete or de-identify your RippaDay sign-in account and personal information associated with the account, except where we need to keep limited records for legal, tax, accounting, fraud prevention, security, or dispute-resolution reasons.</p>

                <h4>Subscriptions and billing</h4>
                <p>Deleting your RippaDay account does not automatically cancel active subscriptions billed by Apple, Google, Stripe, or another payment provider. To stop future billing, cancel your subscription with the provider that bills you. If you need help identifying the provider, contact support.</p>

                <h4>Timing</h4>
                <p>We aim to process verified deletion requests as soon as reasonably practicable. We will let you know if we need more information to verify the request or if limited information must be retained for legitimate reasons.</p>

                <h4>Contact</h4>
                <p>Account deletion and support: <a href="mailto:support@rippaday.com">support@rippaday.com</a></p>
                <p>Privacy questions: <a href="mailto:privacy-policy@rippaday.com">privacy-policy@rippaday.com</a></p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AccountDeletion;
